import { render } from "./PromptCardsModal.vue?vue&type=template&id=5de5b378&scoped=true"
import script from "./PromptCardsModal.vue?vue&type=script&lang=js"
export * from "./PromptCardsModal.vue?vue&type=script&lang=js"

import "./PromptCardsModal.vue?vue&type=style&index=0&id=5de5b378&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de5b378"]])

export default __exports__